import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { connect, useSelector, shallowEqual } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import { login } from "../_redux/authCrud";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { useAuth0 } from "@auth0/auth0-react";

/*
  INTL (i18n) docs:
  https://github.com/formatjs/react-intl/blob/master/docs/Components.md#formattedmessage
*/

/*
  Formik+YUP:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
*/



function Login({ className}) {
  const {
    loginWithRedirect
  } = useAuth0();

  const { authState } = useSelector(
    (state) => ({ authState: state.auth }),
    shallowEqual
  );

  const {redirectTo} = authState;

  //const backgroundImageUrl = toAbsoluteUrl("/media/bg/truck.png");
  const backgroundImageUrl = toAbsoluteUrl("/media/svg/patterns/taieri.svg");

  return (
    <>
      <div
        className={`card card-custom bgi-no-repeat ${className}`}
        style={{  backgroundColor: "#663259", backgroundPosition: "calc(100% + 0.5rem) 100%", backgroundSize: "100% auto", backgroundImage: `url("${backgroundImageUrl}")`  }}
      >
        {/* begin::Body */}
        <div className="card-body d-flex align-items-center">
        <div>
            <h3 className="text-white font-weight-bolder line-height-lg mb-5">Field Genie | Field Track</h3>
            <a onClick={() => loginWithRedirect({returnTo: redirectTo})} className="btn btn-success font-weight-bold px-6 py-3">Login</a>
        </div>
    </div>
        {/* end::Body */}
      </div>
    </>
    );
}

export default injectIntl(connect(null, auth.actions)(Login));
